import styled, { css } from 'styled-components'
import { colors, fonts } from 'modules/dashboard/Home/Dashboard.global.styles'
import FormInput from 'components/UI/FormInput/FormInput'
import { phoneMaxWidth, ipadPortraitMaxWidth } from '../../../../DashboardSettings.styles'

export const Wrapper = styled.div`
  max-width: 830px;
  margin: auto;
  padding: 20px 0;

  @media (max-width: ${ipadPortraitMaxWidth}px) {
    padding: 20px 15px;
  };

  @media (max-width: ${phoneMaxWidth}px) {
    padding: 0 15px;
  };
`

const titleStyle = props => {
  switch (props.type) {
    case 'main':
      return css`
        color: ${colors.darkPurple};
        margin: 60px 0 30px;
        justify-content: center;

        @media (max-width: ${phoneMaxWidth}px) {
          margin: 20px 0 30px;
        };
      `
    case 'sub':
      return css`
        color: ${colors.pink};
        margin: 0;
        text-align: left;
      `
    default:
      return css`
        color: ${colors.pink};
        margin: 60px 0 30px;
        justify-content: center;
      `
  }
}

export const Title = styled.h1`
  display: flex;
  font-size: 24px;

  ${titleStyle};
`

export const TextImageWrapper = styled.div`
  display: flex;
  padding-bottom: ${props => props.textImageStyle};
`

export const Image = styled.div`
  background-image: url(${ASSETS_PATH}/pages/Dashboard/images/girl-watching-video.jpg);
  background-size: contain;
  background-repeat: no-repeat;
  min-width: 400px;
  
  @media (max-width: ${ipadPortraitMaxWidth}px) {
    min-width: 250px;
  };
  
  @media (max-width: ${phoneMaxWidth}px) {
    display: none;
  };
`

export const InfoSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 60px;

  @media (max-width: ${ipadPortraitMaxWidth}px) {
    min-width: 250px;
    margin-left: 30px;
  };

  @media (max-width: ${phoneMaxWidth}px) {
    margin-left: 0;
  };
`

export const Info = styled.p`
  margin: 20px 0 0;
  color: ${colors.darkPurple};
`

export const Link = styled.p`
  margin: 0;
  color: ${colors.blue};
`

export const ButtonTextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const smallPrintStyle = props => {
  switch (props.type) {
    case 'smallBlue':
      return css`
        font-size: 14px;
      `
    case 'smallRed':
      return css`
        font-size: 11px;
        color: ${colors.red};
        margin: 0 0 0 10px;
        
      `
    case 'regularYellow':
      return css`
        font-size: 14px;
        color: ${colors.yellow};
        text-align: center;
        margin-top: -20px;
      `
    case 'regularBlue':
      return css`
        font-size: 14px;
        position: relative;
        margin-left: 34px;

        &:before {
          content: 'i';
          font-weight: bold;
          position: absolute;
          left: -34px;
          top: -4px;
          border: 1px solid;
          border-radius: 50%;
          padding: 2px 9px;
        }
      `
    default:
      return css`
        font-size: 11px;
      `
  }
}

export const SmallPrint = styled.p`
  color: ${colors.darkTeal};

  ${smallPrintStyle};
`
